import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity } from '@adornis/baseql/decorators/entity.js';
import { Field } from '@adornis/baseql/decorators/field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

@Entity()
export class Organization extends MongoEntity {
  static override _class = 'Organization';
  static override _collectionName = 'organizations';

  constructor(doc: PartialEntityData<Organization>) {
    super(doc);
  }

  /** Set by the ERM archive action — non-null means the template is archived. */
  @Field(() => Date)
  archivedAt: Maybe<Date>;

  /**
   * Name of the organization.
   */
  @Field(() => String)
  name: Maybe<string>;

  /**
   * The prompt to use for extraction.
   */
  @Field(() => String)
  extractionPrompt: Maybe<string>;

  /**
   * Which LLM model should be used for extraction.
   */
  @Field(() => String)
  extractionModel: Maybe<string>;
}

/**
 * The only fields `updateOrganization` takes from the caller.
 *
 * Everything else on the document is written by the endpoint that owns it:
 * `_id` and `_class` at creation, `archivedAt` by archive/unarchive. Keeping the
 * list here rather than in the resolver means a new field is opted in where it
 * is declared, and never by accident.
 */
export const ORGANIZATION_EDITABLE_FIELDS = [
  'name',
  'extractionPrompt',
  'extractionModel',
] as const satisfies ReadonlyArray<keyof Organization>;
